import { Form, FormContentRef } from "@/components/Form"
import { FormRenderMode, FormType } from "@/components/Form/types"
import FORM_CONSTANT from "@/core/app/slices/uassist/form.constant"
import { getFormByID } from "@/core/app/slices/uassist/form.util"
import React, { forwardRef, useMemo } from "react"
import { useTranslation } from "react-i18next"

interface RxFormProps {
  formid: string | undefined
  formTemplateList: any[]
  isSaveData: boolean
  setIsSaveData: (val: boolean) => void
}

const RxForm = forwardRef<FormContentRef, RxFormProps>((
  {
    formid,
    formTemplateList,
    isSaveData,
    setIsSaveData,
  }, ref) => {

  const { t } = useTranslation("common")

  const formName = useMemo(() => {
    if (formid && formTemplateList) {
      return getFormByID(formTemplateList, "SMARTRX", formid)?.name || ""
    }
    return ""
  }, [formid, formTemplateList])


  return (
    <>
      {formid && formName && (
        <Form
          ref={ref}
          details={{
            formType: FormType.SMARTRX,
            formName: formName,
            uassistRound: 0,
            fetchSavedData: false,
            isSettings: true,
            displayMeta: {
              formTitle: (
                formName +
                " " +
                t(
                  `uassist.uAssistForm.${formName !== FORM_CONSTANT.LIMITED_TREATMENT
                    ? "templateHeader"
                    : "limitedtreatmentHeader"
                  }`,
                )
              ),
              formDescription: t(
                `uassist.uAssistForm.${formName
                  ?.toLowerCase()
                  .replaceAll(" ", "")}SettingsDescription`,
              ),
            },
          }}
          mode={FormRenderMode.EDIT}
          onChange={(data) => { }}
          showValidationErrors={isSaveData}
          onFormSaved={setIsSaveData}
        />
      )}
    </>
  )
})

export default RxForm
